import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const CloseIcon: FC<IconProps> = ({
  color = theme.palette.text.default,
  size = IconSize.small,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_909_940)">
          <path
            d="M12.182 5.24264C12.4749 4.94975 12.4749 4.47487 12.182 4.18198C11.8891 3.88909 11.4142 3.88909 11.1213 4.18198L8 7.3033L4.87868 4.18198C4.58579 3.88909 4.11091 3.88909 3.81802 4.18198C3.52513 4.47487 3.52513 4.94975 3.81802 5.24264L6.93934 8.36396L3.81802 11.4853C3.52513 11.7782 3.52513 12.253 3.81802 12.5459C4.11091 12.8388 4.58579 12.8388 4.87868 12.5459L8 9.42462L11.1213 12.5459C11.4142 12.8388 11.8891 12.8388 12.182 12.5459C12.4749 12.253 12.4749 11.7782 12.182 11.4853L9.06066 8.36396L12.182 5.24264Z"
            fill={color}
          />
        </g>
      </svg>
    </Icon>
  </>
)
